<template>
  <div>
    <div class="vx-col flex justify-center flex-wrap">
      <div class="w-full flex justify-center">
        <vs-upload
          action="#"
          :limit="1"
          :show-upload-button="false"
          text="Загрузить файл"
          @change="changeAprtmentsFile"
          @on-delete="deleteApartmentsFile"
          class="w-auto mx-auto"
          ref="uploader"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        />
      </div>
      <vs-button type="border" color="success" @click="importApartments">Загрузить</vs-button>
      <div class="w-full text-center mt-4">
        <p>Формат файла - xls, xlsx.</p>
        <p>Скачать пример можно <a href="#">здесь</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:    "UploadApartmentsTempUsers",
  data() {
    return {
      apartmentFile:          null,
      apartmentsNeedTranslit: true,
      apartmentsType:         0,
    };
  },
  methods: {
    changeAprtmentsFile( event, file ) {
      this.apartmentFile = file[file.length - 1];
    },
    deleteApartmentsFile() {
      this.apartmentFile = null;
    },
    updateApartmentsImportHeight() {
      this.$emit('openExtraSettings');
    },
    async importApartments() {
      if (!this.apartmentFile) return;
      let body = new FormData();
      body.append('apartments_file', this.apartmentFile);
      body.append('buildings_id', this.$store.getters['appUser/selectedHouse'].id);
      body.append('mc_id', this.$store.getters['appUser/selectedHouse'].management_companies_id);
      body.append('users_id', this.$store.getters['appUser/id']);
      try {
        this.$vs.loading({ type: 'default' });
        let { data } = await this.$http.post('users/import/reg_temp', body);
        if (data === 'error') {
          this.$vs.notify({ color: 'danger', title: 'Ошибка загрузки', text: 'Не найдены совпадения' });
        } else if (data === 'wrong file format') {
          this.$vs.notify({ color: 'danger', title: 'Ошибка загрузки', text: 'Файл имеет не верный формат' });
        } else {
          // this.$emit('uploaded', {info: data});
          this.$vs.notify({ color: 'success', title: 'Импорт завершен', text: 'Файл импортирован' });
          this.resetFile();
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      } finally {
        this.$vs.loading.close();
      }
    },
    resetFile() {
      this.apartmentFile = null;
      this.$refs.uploader.srcs = [];
      this.$refs.uploader.itemRemove = [];
      this.$refs.uploader.filesx = [];
    },
  },
  watch:   {
    apartmentsType() {
      this.resetFile();
    },
  },
};
</script>
